/**
 * RequireSenhaDefinida — #827: com senha provisória (vigente ou vencida), nada
 * da área autenticada renderiza antes de /definir-senha, nem o cadastro de MFA.
 * A trava de verdade é o backend (403 SENHA_PROVISORIA em /v1).
 */
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/features/auth/auth-context'

export function RequireSenhaDefinida() {
  const { user } = useAuth()
  if (user?.senhaProvisoria) return <Navigate to="/definir-senha" replace />
  return <Outlet />
}
